import { render, staticRenderFns } from "./ConstructionAndEventPowerPage.vue?vue&type=template&id=18916bf1&scoped=true"
import script from "./ConstructionAndEventPowerPage.vue?vue&type=script&lang=js"
export * from "./ConstructionAndEventPowerPage.vue?vue&type=script&lang=js"
import style0 from "./ConstructionAndEventPowerPage.vue?vue&type=style&index=0&id=18916bf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18916bf1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
